export type AccessParam = {
    codeAccess: string
}

export const generalUseUrl = 'https://services.gerep.fr/blobs/medias/s/383736018900000a/Charte_utilisation_Application_IRIS_FINAL_(2).pdf'

export enum SIGNUP_FIELDS {
    INSURANCE_NUMBER = 'idAdherent',
    FIRST_NAME = 'prenom',
    LAST_NAME = 'nom',
    SOCIAL_SECURITY_NUMBER = 'niss',
    BIRTH_DATE = 'dateNaissance',
    EMAIL = 'email',
    CONFIRM_EMAIL = 'confirmEmail',
    PASSWORD = 'password',
    CONFIRM_PASSWORD = 'confirmPassword',
    CAPTCHA_RESPONSE = 'captcharesponse',
    TERMS_AND_CONDITIONS = 'newsletter',
    GLOBAL = 'globalError'
}





